module.exports = __webpack_public_path__ + "img/applicationLenders.81d6d412.png";